import { FC } from 'react';
import { match } from 'ts-pattern';
import { MessageMediumTab } from 'modules/intelligentInsights/frequencyOptimization/types';
import { SupportedMediums } from 'modules/frequencyManagement/lib/types';
import { SummaryBannerLoading } from 'modules/frequencyManagement/lib/components/summaryBanner/SummaryBannerLoading';
import { SummaryBannerError } from 'modules/frequencyManagement/lib/components/summaryBanner/SummaryBannerError';
import { useManagementSettingsContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/ManagementSettingsContext';
import { BreakdownSummaryBanner } from 'modules/intelligentInsights/frequencyOptimization/components/breakdown/BreakdownSummaryBanner';

export type BreakdownBannerProps = {
  messageMedium: MessageMediumTab;
};
export const BreakdownBanner: FC<BreakdownBannerProps> = ({ messageMedium }) => {
  const { frmManagementSettings, isLoading, isReady, isError } = useManagementSettingsContext();
  const supportedMessageMedium = messageMedium as SupportedMediums;
  const bannerContent = match({ isLoading, isReady, isError })
    .with({ isReady: true }, () => (
      <BreakdownSummaryBanner
        config={frmManagementSettings}
        messageMedium={supportedMessageMedium}
      />
    ))
    .with({ isLoading: true }, () => <SummaryBannerLoading asExternalContent />)
    .with({ isLoading: false, isReady: false, isError: false }, () => (
      <SummaryBannerLoading asExternalContent />
    ))
    .with({ isError: true }, () => <SummaryBannerError messageMedium={supportedMessageMedium} />)
    .otherwise(() => <SummaryBannerError messageMedium={supportedMessageMedium} />);

  return <>{bannerContent}</>;
};
